import { Component, OnInit } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { Router } from '@angular/router';
import { SessionService } from 'app/components/common/session/session.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-hall-list',
  templateUrl: './hall-list.component.html',
  styleUrls: ['./hall-list.component.scss']
})
export class HallListComponent implements OnInit {

  loader: any = {
    count: 0
  };
  alertType: string = '';
  alertMessage: string = '';
  cards: Array<any> = [];

  currentYear: number;

  availableLanguages: string[] = ['ca', 'es', 'en'];
  currentLanguage: string = 'es';

  constructor(private catalogueService: CatalogueService, private router: Router, private sessionService: SessionService, private translate: TranslateService,
    private titleService:Title
  ) {
    this.currentYear = new Date().getFullYear();
  }

  getHalls(getHallsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getHalls(getHallsIn)
      .subscribe((data: object) => {
        this.getHallsOk(data);
      },
        error => {
          this.getHallsError(error);
        });

  }

  getHallsOk(data) {

    this.loader.count--;
    this.cards = data;

  }

  getHallsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  goTo(card) {
    
    const queryParams = { filter: 'ONLY_EXHIBITORS'};

    this.sessionService.set('catalogId', card.id, false);
    this.sessionService.set('eventName', card.eventName, false);
    //this.sessionService.set('eventData', card, false);
    //this.router.navigate([card.id + '/exhibitors-list']);

    const url = this.router.serializeUrl(this.router.createUrlTree([card.eventName + '/home'], {queryParams}));
    //https://localhost/barcelonawineweek/home?filter=ONLY_EXHIBITORS&lang=es_ES
    window.open(url, '_blank');
  }

  ngOnInit() {

    this.translate.setDefaultLang(this.currentLanguage);
    this.translate.use(this.currentLanguage);

    let getHallsIn = {
      language: 'es_ES'
    };

    this.getHalls(getHallsIn);

    this.translate.get('HALLS_LIST.TITLE').subscribe((translatedValue: string) => {
      this.titleService.setTitle(translatedValue);
    });

  }

  setLang(lang: string) {
    this.currentLanguage = lang;
    this.translate.use(this.currentLanguage);
  }


}
